import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'mono-common-back-to-navigation-bar',
  templateUrl: './back-to-navigation-bar.component.html',
  styleUrls: ['./back-to-navigation-bar.component.scss']
})
export class BackToNavigationBarComponent implements OnInit {
  @Input() public linkText:string;
  @Input() public linkTo: string;
  @Input() public position?: string;

  constructor() { }

  ngOnInit(): void {
  }

}
